module.exports = __webpack_public_path__ + "img/Edit-icon.49079c79.svg";